<template>
  <div>
    <v-simple-table v-if="filteredSchedules && filteredSchedules.length > 0">
      <tbody>
        <tr v-for="schedule in filteredSchedules" :key="schedule.id">
          <td style="width: 50px">
            <v-icon v-if="schedule.courseSchedule.rrule">
              mdi-calendar-sync
            </v-icon>
            <v-icon v-else> mdi-calendar-outline </v-icon>
          </td>
          <td>
            {{ schedule.startDate | formatDate }} -
            {{ schedule.endDate | formatDate }}
            <span class="ml-5">
              {{ schedule.courseSchedule.startTime | formatTime }} -
              {{ schedule.courseSchedule.endTime | formatTime }}
            </span>
            <span v-if="canViewRate && schedule.hourlyRate" class="ml-5">
              {{ schedule.hourlyRate | currency }}/hr
              <span v-if="schedule.paidPrepTimeInMins">
                + {{ schedule.paidPrepTimeInMins }} mins prep
              </span>
            </span>
            <!-- {{schedule}} -->
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <div v-else class="mx-4 text-caption">No active schedule</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  props: {
    courseId: {
      type: Number,
      required: true,
    },
    teacherId: {
      type: Number,
      required: true,
    },
    activeOnly: {
      type: Boolean,
      required: false,
    },
  },
  data: () => ({
    teacherSchedules: [],
  }),
  computed: {
    ...mapGetters(["isAppLoading", "currentUser"]),
    canViewRate() {
      return this.currentUser.roles.includes("VIEWRATE");
    },
    filteredSchedules() {
      if (this.activeOnly) {
        return this.teacherSchedules.filter(
          (ts) => ts.endDate == null || moment(ts.endDate).isAfter(moment())
        );
      } else {
        return this.teacherSchedules;
      }
    },
  },
  mounted() {
    this.initTeacherSchedules();
  },
  filters: {
    formatTime(time) {
      return moment(time, "HH:mm").format("h:mma");
    },
    formatDate(date) {
      if (date) {
        return moment(date).format("ddd, MMM DD, yyyy");
      } else {
        return "No End Date";
      }
    },
  },
  methods: {
    initTeacherSchedules() {
      const params = {
        courseId: this.courseId,
        teacherId: this.teacherId,
      };
      this.$axios.get("/teacher/course-schedules", { params }).then((resp) => {
        // console.log("teacher schedules: ");
        // console.log(resp.data);
        this.teacherSchedules = resp.data.data;
      });
    },
    formatExcludeDates(scheduleExclusions) {
      if (scheduleExclusions && scheduleExclusions.length > 0) {
        const dates = scheduleExclusions
          .map((d) => moment(d.excludeDate).format("ddd MMM, DD YYYY"))
          .join(", ");
        return dates;
      } else {
        return "";
      }
    },
  },
};
</script>